import { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

const LOGOMARK = 'https://adthlete.us-iad-1.linodeobjects.com/public/adthlete_logomark.png'

/** Finishes an emailed sign-in link, or a Google / Apple sign-in, which lands here too */
export default function VerifyMagicLink() {
  const { token } = useParams<{ token: string }>()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  // Where to land afterwards; only paths in this app
  const returnTo = searchParams.get('returnTo')
  const destination = returnTo?.startsWith('/') && !returnTo.startsWith('//') ? returnTo : '/'
  const { verifyMagicLink, athlete } = useAuth()
  const [error, setError] = useState('')
  const attempted = useRef(false)

  useEffect(() => {
    if (attempted.current) return
    attempted.current = true
    if (!token) {
      setError('This link is missing its code.')
      return
    }
    verifyMagicLink(token).catch((err: unknown) => {
      setError(err instanceof Error ? err.message : "We couldn't verify that link.")
    })
  }, [token, verifyMagicLink])

  useEffect(() => {
    if (!athlete) return
    const pendingInvite = localStorage.getItem('pendingMarketerInviteToken')
    if (pendingInvite) {
      localStorage.removeItem('pendingMarketerInviteToken')
      navigate(`/marketer-invite/${pendingInvite}`, { replace: true })
    } else {
      navigate(destination, { replace: true })
    }
  }, [athlete, navigate, destination])

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F4F7EF] px-4 py-8">
      <div className="w-full max-w-md rounded-[28px] bg-[#FFFFFF] px-6 py-10 text-center shadow-[0_20px_60px_rgba(16,24,40,0.08)]">
        <img src={LOGOMARK} alt="" className="mx-auto h-10 w-10" />
        <h1 className="text-2xl font-bold mt-6 tracking-tight text-[#0F172A]">
          {error ? "That link didn't work" : 'Signing you in'}
        </h1>
        {error ? (
          <>
            <p className="mt-3 rounded-xl border border-[#FECACA] bg-[#FEF2F2] px-4 py-3 text-sm text-[#B91C1C]">
              {error}
            </p>
            <button
              onClick={() => navigate('/signin')}
              className="mt-6 inline-flex h-12 w-full items-center justify-center rounded-xl bg-[#C0FD72] font-semibold text-[#0F172A] hover:bg-[#B2F25E]"
            >
              Back to sign in
            </button>
          </>
        ) : (
          <>
            <div className="mx-auto mt-6 h-8 w-8 animate-spin rounded-full border-b-2 border-[#65A30D]" />
            <p className="mt-4 text-[#4B5563]">One moment while we check your link.</p>
          </>
        )}
      </div>
    </div>
  )
}
